import { getBearerToken } from '@/src/auth/token-storage';
import { client } from './client';

export function setBearerToken(token: string | null = getBearerToken()) {
  client.setConfig({
    auth: token ?? undefined,
    baseUrl: process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://localhost:3001',
    credentials: 'include',
  });
}
